import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useRef, useState } from 'react';
import { EmbersMenuLaunchButton } from './menuLaunchButton';
import { EmbersMenu } from './menu';
export var EmbersMenuContainer = function EmbersMenuContainer(props) {
  var renderTriggerElem = props.renderTriggerElem,
    renderMenuItems = props.renderMenuItems,
    disabled = props.disabled,
    buttonText = props.buttonText,
    buttonClass = props.buttonClass,
    label = props.label,
    id = props.id,
    placement = props.placement,
    onClose = props.onClose,
    onOpen = props.onOpen,
    tabIndex = props.tabIndex,
    _props$popperModifier = props.popperModifiers,
    popperModifiers = _props$popperModifier === void 0 ? [] : _props$popperModifier,
    className = props.className,
    shouldPreventClose = props.shouldPreventClose;
  var anchorElRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuIsOpen = _useState2[0],
    setMenuIsOpen = _useState2[1];
  var handleCloseMenu = function handleCloseMenu() {
    var _anchorElRef$current;
    setMenuIsOpen(false);
    (_anchorElRef$current = anchorElRef.current) === null || _anchorElRef$current === void 0 || _anchorElRef$current.focus();
    anchorElRef.current = null;
    onClose === null || onClose === void 0 || onClose();
  };
  var isMenuOpen = function isMenuOpen() {
    return !!anchorElRef.current;
  };

  // TODO: there is a bug for the default EmbersMenuLaunchButton, and it's hard to customize style for it, I think it's no need to set a default button
  var handleOpenMenu = function handleOpenMenu(evt) {
    if (isMenuOpen()) {
      handleCloseMenu();
    } else {
      // open the menu
      anchorElRef.current = evt.currentTarget;
      setMenuIsOpen(true);
      onOpen === null || onOpen === void 0 || onOpen();
    }
  };
  var ariaProps = {
    'aria-controls': "EmbersMenu-".concat(id),
    'aria-haspopup': 'menu',
    'aria-expanded': menuIsOpen
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderTriggerElem ? renderTriggerElem(handleOpenMenu, handleCloseMenu, menuIsOpen, ariaProps) : /*#__PURE__*/React.createElement(EmbersMenuLaunchButton, {
    onOpenMenuRequest: handleOpenMenu,
    onCloseMenuRequest: handleCloseMenu,
    menuIsOpen: menuIsOpen,
    tabIndex: tabIndex || 0,
    className: buttonClass,
    disabled: disabled,
    label: label,
    ariaProps: ariaProps
  }, buttonText), /*#__PURE__*/React.createElement(EmbersMenu, {
    id: "EmbersMenu-".concat(id),
    anchorEl: anchorElRef.current,
    open: menuIsOpen,
    onClose: handleCloseMenu,
    placement: placement,
    modifiers: popperModifiers,
    className: className,
    shouldPreventClose: shouldPreventClose
  }, renderMenuItems(handleCloseMenu)));
};